module.exports = __webpack_public_path__ + "img/next.7426043b.png";